const LOCAL_STORAGE_KEY = "salesLead-showTranslationKey";
export const isShowTranslationKey = () => {
  const res = window.sessionStorage.getItem(LOCAL_STORAGE_KEY);
  return res;
};

// Allow the user to show Phrase Keys
// phrase=show
// Shows the keys in the web app
export const setShowTranslationKey = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("phrase") === "show") {
    window.sessionStorage.setItem(LOCAL_STORAGE_KEY, "true");
    return true;
  }

  window.sessionStorage.removeItem(LOCAL_STORAGE_KEY);
  return false;
};
